import type { TPreapprovalOfferStep } from 'shared/types/TRankingService';

export const IMPLEMENTED_PREAPPROVAL_OFFER_STEPS = [
  'delivery',
  'application',
  'confirmation',
  'iframe',
] as TPreapprovalOfferStep[];
